import React from 'react';
import { Link } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap';

class Timeline extends React.Component {
  buildChildren() {
    return (
		this.props.list.map((child, cKey) => {
			const items = child.items.map((item, iKey) => {
			  return(
				<li key={iKey}>
				  <Glyphicon glyph={item.icon} />
				  <div className="timeline-item">
					 { item.time && <span className="time"><i className="time"></i> {item.time}</span> }
					<h3 className="timeline-header">
					  {item.href && <Link to={item.href}>{item.text}</Link>}
					  {!item.href && <b>{item.text}</b>}
					</h3>
					{item.description &&
					  <div className="timeline-body">
					   {item.description}
					  </div>
					}
	  
				  </div>
				</li>
			  );
			});
	  
			return(
			  <React.Fragment key={cKey}>
				<li className="time-label">
				  <span className="bg-blue">{child.date}</span>
				</li>
				{items}
			  </React.Fragment>
			);
		})
	);
  }

	render() {
    return(
      <ul className="timeline">
        {this.buildChildren()}
        <li>
          <Glyphicon glyph="time" />
        </li>
      </ul>
    );
	}
}

export default Timeline;



// WEBPACK FOOTER //
// ./src/fw/components/timeline/Timeline.js